var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages, dropFilesHere } from './messages';
/**
 * @hidden
 */
var TIME_TO_CHECK_DRAG = 100;
/**
 * @hidden
 */
var UploadDropZone = /** @class */ (function (_super) {
    __extends(UploadDropZone, _super);
    function UploadDropZone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._documentActive = false;
        _this._elementActive = false;
        _this.onDocumentDragEnter = function () {
            if (!_this.documentActive) {
                _this.documentActive = true;
                var documentInterval = function () {
                    if (_this.isDragOver(_this._lastDocumentDragOver)) {
                        _this.documentActive = false;
                        clearInterval(_this._documentInterval);
                        _this._documentInterval = null;
                        _this._lastDocumentDragOver = null;
                    }
                };
                _this._documentInterval = setInterval(documentInterval, TIME_TO_CHECK_DRAG);
            }
        };
        _this.onDocumentDragOver = function () {
            _this._lastDocumentDragOver = new Date();
        };
        _this.onElementDragEnter = function () {
            if (!_this.elementActive) {
                _this.elementActive = true;
                var elementInterval = function () {
                    if (_this.isDragOver(_this._lastElementDragOver)) {
                        _this.elementActive = false;
                        clearInterval(_this._elementInterval);
                        _this._elementInterval = null;
                        _this._lastElementDragOver = null;
                    }
                };
                _this._elementInterval = setInterval(elementInterval, TIME_TO_CHECK_DRAG);
            }
        };
        _this.onElementDragOver = function (event) {
            event.preventDefault();
            _this._lastElementDragOver = new Date();
        };
        _this.onDrop = function (event) {
            event.preventDefault();
            var droppedFiles = event.dataTransfer.files;
            if (droppedFiles.length > 0 && !_this.props.disabled && _this.props.onAdd) {
                _this.props.onAdd.call(undefined, droppedFiles);
            }
        };
        _this.isDragOver = function (prevDate) {
            return (new Date().getTime() - (prevDate || new Date()).getTime()) > TIME_TO_CHECK_DRAG;
        };
        return _this;
    }
    Object.defineProperty(UploadDropZone.prototype, "documentActive", {
        get: function () {
            return this._documentActive;
        },
        set: function (active) {
            var prevActive = this.documentActive;
            this._documentActive = active;
            if (active !== prevActive) {
                this.forceUpdate();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadDropZone.prototype, "elementActive", {
        get: function () {
            return this._elementActive;
        },
        set: function (active) {
            var currentActive = this._elementActive;
            this._elementActive = active;
            if (active !== currentActive) {
                this.setState({});
            }
        },
        enumerable: true,
        configurable: true
    });
    UploadDropZone.prototype.componentDidMount = function () {
        document.addEventListener('dragenter', this.onDocumentDragEnter);
        document.addEventListener('dragover', this.onDocumentDragOver);
    };
    UploadDropZone.prototype.componentWillUnmount = function () {
        document.removeEventListener('dragenter', this.onDocumentDragEnter);
        document.removeEventListener('dragover', this.onDocumentDragOver);
    };
    UploadDropZone.prototype.render = function () {
        var _a = this.props, addButtonComponent = _a.addButtonComponent, statusComponent = _a.statusComponent;
        var localizationService = provideLocalizationService(this);
        var dropFilesMessage = localizationService
            .toLanguageString(dropFilesHere, messages[dropFilesHere]);
        var className = classNames('k-dropzone', this.documentActive ? 'k-dropzone-active' : '', this.elementActive ? 'k-dropzone-hovered' : '');
        return (React.createElement("div", { className: className, onDrop: this.onDrop, onDragEnter: this.onElementDragEnter, onDragOver: this.onElementDragOver },
            addButtonComponent,
            React.createElement("div", { className: 'k-dropzone-hint' }, dropFilesMessage),
            statusComponent));
    };
    return UploadDropZone;
}(React.Component));
export { UploadDropZone };
registerForLocalization(UploadDropZone);
//# sourceMappingURL=UploadDropZone.js.map